import { useParams } from 'react-router'
import { LoadingDots } from 'src/components/LoadingDots/LoadingDots'
import { VideoCallRoom } from 'src/features/videoCall/components'

import { usePatientVideoCallToken } from '../../hooks/usePatientVideoCallToken'
import { PatientVideoCallGuard } from '../PatientVideoCallGuard/PatientVideoCallGuard'

type Param = {
  patientVideoCallUid: string
}

export const PatientVideoCallForPatientScreen: React.FC = () => {
  const { patientVideoCallUid = '' } = useParams<Param>()

  return (
    <PatientVideoCallGuard>
      {({ diseaseUid }) => {
        return (
          <PatientVideoCallForPatientBase
            patientVideoCallUid={patientVideoCallUid}
            diseaseUid={diseaseUid}
          />
        )
      }}
    </PatientVideoCallGuard>
  )
}

type Props = {
  patientVideoCallUid: string
  diseaseUid?: string
}

const PatientVideoCallForPatientBase: React.FC<Props> = ({
  patientVideoCallUid,
}) => {
  const data = usePatientVideoCallToken({
    patientVideoCallUid,
  })

  if (!data) {
    return <LoadingDots />
  }

  return (
    <VideoCallRoom
      roomUid={data.videoCallRoomUid}
      token={data.token}
      videoCallUserUid={data.videoCallUserUid}
      screenShareUserUid={data.screenShareUserUid}
      screenShareToken={data.screenShareToken}
      canShareScreen={false}
      scene="ESource"
      agoraCloudProxyMode={data.agoraCloudProxyMode}
    />
  )
}
